import {GetExamsPreparationParams} from 'domain/usecases';
import {makeGetExamsPreparation} from 'main/factories/usecases';

export const getExamsPreparation = async (params: GetExamsPreparationParams) =>
	makeGetExamsPreparation().get(params);
